import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_2 = { class: "lg:col-span-1" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-[25px]" }
const _hoisted_4 = { class: "lg:col-span-2" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_6 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_7 = { class: "lg:col-span-1" }
const _hoisted_8 = { class: "lg:col-span-2" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-[25px]" }
const _hoisted_10 = { class: "lg:col-span-2" }
const _hoisted_11 = { class: "lg:col-span-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveTotalProperty = _resolveComponent("ActiveTotalProperty")!
  const _component_RevenueChart = _resolveComponent("RevenueChart")!
  const _component_NewListingsSoldPropertiesChart = _resolveComponent("NewListingsSoldPropertiesChart")!
  const _component_PropertiesForSaleChart = _resolveComponent("PropertiesForSaleChart")!
  const _component_PropertiesForRentChart = _resolveComponent("PropertiesForRentChart")!
  const _component_NewCustomers = _resolveComponent("NewCustomers")!
  const _component_MostSalesLocation = _resolveComponent("MostSalesLocation")!
  const _component_RentalIncomeChart = _resolveComponent("RentalIncomeChart")!
  const _component_SocialSearchChart = _resolveComponent("SocialSearchChart")!
  const _component_RecentProperty = _resolveComponent("RecentProperty")!
  const _component_CustomerReviews = _resolveComponent("CustomerReviews")!
  const _component_TopProperty = _resolveComponent("TopProperty")!
  const _component_LatestTransaction = _resolveComponent("LatestTransaction")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ActiveTotalProperty),
          _createVNode(_component_RevenueChart)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NewListingsSoldPropertiesChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_PropertiesForSaleChart),
      _createVNode(_component_PropertiesForRentChart),
      _createVNode(_component_NewCustomers)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MostSalesLocation)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_RentalIncomeChart),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_SocialSearchChart),
          _createVNode(_component_RecentProperty)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_CustomerReviews)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TopProperty)
      ])
    ]),
    _createVNode(_component_LatestTransaction)
  ], 64))
}